var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link.title)?_c('div',{class:[
    'floating-cta',
    _vm.isVisible ? 'floating-cta--visible' : 'floating-cta--hidden'
  ]},[_c('form-button',{attrs:{"background-color":_vm.backgroundColor,"tag":"recess-link","sanity-link":_vm.link}},[_vm._v("\n    "+_vm._s(_vm.link.title)+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }